import * as React from 'react';
import { useEffect, useContext, useState } from 'react';
import ContainerHeader from '../../../components/ContainerHeader';
import { Button } from '@mui/material';
import CampaignForm from '../../../components/forms/CampaignForm';
import CampaignConfig from '../../../components/CampaignConfig';
import CustomDialog from '../../../components/Dialogs';

import { useDispatch } from 'react-redux';
import FeeFilter from './FeeFilter';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Campaign } from '@tff/types/TFF';
import { filterActiveFee, FeeFilter as FeeFilterType } from './filter-active-fee';
import { useTypedSelector } from '../../../reducers';
import {
  CAMPAIGN_STATES,
  saveCampaign,
  loadCampaignsOrderedByPriority,
  resetCampaign,
} from '../../../reducers/Campaign/campaignSlice';
import { IntlMessages } from '../../../util';
import { LoadingContext } from '../../../contexts/LoadingContextProvider';
import { useLocation } from 'react-router-dom';

const Feeconfigs: React.FC = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const { campaigns, campaign, state, campaignLoading } = useTypedSelector(({ campaignData }) => campaignData);
  const [displayedCampaigns, setDisplayedCampaigns] = useState<Campaign[]>();
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { showLoading, closeLoading } = useContext(LoadingContext);
  const location = useLocation();

  useEffect(() => {
    campaignLoading ? showLoading() : closeLoading();
  }, [campaignLoading]);

  useEffect(() => {
    if (location.hash.indexOf('#search') > -1) {
      setShowFilter(true);
    }

    if (campaigns?.length === 0 && state === CAMPAIGN_STATES.UNKOWN) {
      dispatch(loadCampaignsOrderedByPriority());
    }
    if (campaigns?.length > 0) {
      //dispatch(ResetCampaign());
      setDisplayedCampaigns(campaigns);
    }
  }, [dispatch, campaigns, state]);

  useEffect(() => {
    dispatch(loadCampaignsOrderedByPriority());
  }, [campaign, dispatch]);

  const handleAddCampaign = (values: Campaign) => {
    setOpenDialog(false);
    dispatch(saveCampaign(values));
  };

  const handleOpenNewCampaign = () => {
    dispatch(resetCampaign());
    setOpenDialog(true);
  };

  /**
   * @description a little function to help us with reordering the result
   * @param list
   * @param startIndex
   * @param endIndex
   */
  const reorder = (list: Campaign[] | undefined, startIndex: number, endIndex: number) => {
    const result = Array.from(list as Campaign[]);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  /**
   *
   * @param result
   */
  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(displayedCampaigns, result.source.index, result.destination.index);
    setDisplayedCampaigns(items);
  };

  /**
   *
   * @param values
   */
  const handleFilter = (values: FeeFilterType) => {
    setTimeout(() => {
      setDisplayedCampaigns([]);
    }, 100);

    setTimeout(() => {
      setDisplayedCampaigns(campaigns);
    }, 100);
  };

  return (
    <div className="app-wrapper">
      <ContainerHeader
        title={<IntlMessages id="pages.settings.fee-config" />}
        subtitle={<IntlMessages id="pages.settings.fee-config.description" />}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 40 }}>
        <Button variant="contained" color="primary" onClick={handleOpenNewCampaign}>
          <IntlMessages id="pages.fees.new-campaign" />
        </Button>
        <CustomDialog
          initialOpen={openDialog}
          form
          onCancel={() => setOpenDialog(false)}
          onConfirm={() => setOpenDialog(false)}
          width="lg"
        >
          <CampaignForm
            isNew
            onSubmit={(values: Campaign) => handleAddCampaign(values)}
            onCancel={() => setOpenDialog(false)}
          />
        </CustomDialog>
      </div>
      {/* FeeFilter */}
      {showFilter && <FeeFilter onFilter={handleFilter} />}
      {/* List of Campaigns */}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={'droppable'}>
          {provided => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              {displayedCampaigns?.map((campaign, index) => (
                <CampaignConfig campaign={campaign} key={index} index={index} />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {/* <ConfigList /> */}
    </div>
  );
};

export default Feeconfigs;
